var map = {
	"./bars-solid.svg": 3967,
	"./check-solid.svg": 6578,
	"./close.svg": 8302,
	"./long-arrow-left-light.svg": 9548,
	"./question-circle-light.svg": 2870,
	"./trash-alt-solid.svg": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2064;